var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlohaaLogoWoText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9427 17.2789C24.1045 18.0306 23.9177 18.8149 23.4342 19.413C22.9517 20.011 22.2239 20.3586 21.4549 20.3586H2.54577C1.77673 20.3586 1.04942 20.011 0.565899 19.413C0.0828911 18.8149 -0.1039 18.0306 0.0574425 17.2789C1.25911 11.6904 6.28209 7.63448 12.0003 7.63448C16.8859 7.63448 21.292 10.5391 23.2261 15.0343C23.5365 15.755 23.7778 16.5103 23.9427 17.2789ZM2.54781 7.90729C3.02573 7.90729 3.50925 7.77292 3.93932 7.49146C6.33858 5.92029 9.12619 5.08965 12.0003 5.08965C14.8744 5.08965 17.662 5.91978 20.0608 7.49095C21.2375 8.26153 22.8143 7.93172 23.5839 6.75601C24.3539 5.5803 24.0246 4.00301 22.8489 3.23295C19.619 1.11769 15.8674 0 12.0003 0C8.1332 0 4.38161 1.11769 1.15121 3.23295C-0.0250098 4.00251 -0.353802 5.57979 0.416263 6.75601C0.904361 7.50215 1.71769 7.90729 2.54781 7.90729Z",
    fill: "#F8153B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlohaaLogoWoText);
export default __webpack_public_path__ + "static/media/alohaaLogoWOText.c351ab5a000371f14b57cb0b84667c11.svg";
export { ForwardRef as ReactComponent };